import { useEffect, useRef } from "react";
import { IconX } from "@tabler/icons-react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  maxWidth?: string;
}

export function Modal({ open, onClose, title, subtitle, children, footer, maxWidth = "560px" }: ModalProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const d = dialogRef.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    if (!open && d.open) d.close();
  }, [open]);

  return (
    <dialog
      ref={dialogRef}
      onClose={onClose}
      onClick={(e) => {
        if (e.target === dialogRef.current) onClose();
      }}
      className="bg-transparent p-0 backdrop:bg-black/40 backdrop:backdrop-blur-sm"
    >
      <div
        className="bg-surface-2 border border-border rounded-xl overflow-hidden"
        style={{ width: "min(94vw, " + maxWidth + ")" }}
      >
        <header className="flex items-start justify-between px-4 py-3 border-b border-border bg-surface-1">
          <div>
            <div className="text-[15px] font-medium">{title}</div>
            {subtitle && <div className="text-[11px] text-text-secondary mt-0.5">{subtitle}</div>}
          </div>
          <button
            onClick={onClose}
            className="text-text-secondary hover:text-text-primary p-0.5"
            aria-label="Close"
          >
            <IconX size={18} />
          </button>
        </header>
        <div className="p-4 max-h-[70vh] overflow-y-auto text-sm">{children}</div>
        {footer && (
          <footer className="px-4 py-3 border-t border-border bg-surface-1 flex justify-end gap-2">
            {footer}
          </footer>
        )}
      </div>
    </dialog>
  );
}
